import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { CreateTenantMutation, Tenant, TenantInput } from '#/graphql/types';
import { createTenant } from '#/graphql/mutations'
import { get, omit, pick } from 'lodash';

const q = gql(createTenant);

const useTenantCreate = () => {
    const [mutation, result] = useMutation<CreateTenantMutation>(q);
    const createTenant = useCallback(
        async (tenant: TenantInput) => {
            const response = await mutation({
                variables: {
                    data: pick(tenant, ['name', 'address', 'contacts', 'isActive', 'cognitoGroupName', 'tisId', 'plan']),
                },
            });
            return get(response, 'data.createTenant', undefined);
        },
        [mutation],
    );

    return { createTenant, result };
};
// Used in the modules Form file
export default useTenantCreate;